import React from "react";
import Tooltip from "@8x8/oxygen-tooltip";
import { getEnv } from "@/env";
import { Tag } from "@/react/styled";

const YEAR = new Date().getFullYear();

export const AppVersion = ({ isCompact }) => {
  return (
    <Tag
      variant={"light"}
      hasError={false}
      isFocused={false}
      marginLeft={4}
      marginBottom={8}
    >
      <Tooltip title={getEnv("VUE_APP_VERSION")}>
        <span>&copy; {!isCompact && `8x8 ${YEAR} by TAP Team`}</span>
      </Tooltip>
    </Tag>
  );
};
